/**
 * 线上环境
 */
export const ONLINEHOST = 'http://jq.emof.cn'

/**
 * 测试环境
 */
// export const QAHOST = 'http://192.168.2.160'
export const QAHOST = 'http://jq.emof.cn'

/**
 * 上传地址
 */
export const upFeil = process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST


/**
 * 打分表模版地址
 */
export const excelFile = upFeil + '/download/template.xlsx'

/**
 * 打分表导出地址
 */
export const exportExcelFile = upFeil + '/admin/import/score'


/*
* 缓存字段
* */
export const localAnStore = [
  {
    key: 'user',
    type: 'localStorage'
  },
  {
    key: 'token',
    type: 'localStorage'
  }
]
